import { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';

import IconMapPin from '@zvuk-b2b/react-uikit/ui/icons/MapPin';

import { TEXTS } from './texts';

import styles from './index.module.scss';

interface PointAddressesListProps {
  id: PointsListCheckboxGroupPointType['id'];
  address: PointsListCheckboxGroupPointType['address'];
  title?: PointsListCheckboxGroupPointType['title'];
  withDevice?: boolean;
}

const PointAddressItem: FC<PointAddressesListProps> = ({ id, address, title, withDevice }) => (
  <div
    key={id}
    className={styles.listRow}>
    <IconMapPin className={styles.listIcon} />
    <div>
      <div>{address || title}</div>
      {withDevice !== undefined && (
        <div className={withDevice ? styles.withDevice : styles.withoutDevice}>
          {withDevice ? TEXTS.TRACK_LOADING : TEXTS.NO_DEVICE}
        </div>
      )}
    </div>
  </div>
);

export default memo(PointAddressItem);
